import { Component, OnInit } from '@angular/core';
import { RegistrationService } from 'src/app/services/registration.service';
import { RegistrationVerify } from 'src/app/models/registration-verify.model';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { from, Observable, Subject } from 'rxjs';
import { ContactService } from 'src/app/services/contact.service';

@Component({
  selector: 'app-registration-verify',
  templateUrl: './registration-verify.component.html',
  styleUrls: ['./registration-verify.component.scss']
})
export class RegistrationVerifyComponent implements OnInit {
  submitted: boolean = false;
  isRequestSuccess: boolean = false;
  registrationVerify: RegistrationVerify = new RegistrationVerify();
  currentUser: any;
  isEnoughNumber = false;
  form: FormGroup;
  contacts: any;
  qrImage: any;
  title: any;

  constructor(private registrationService: RegistrationService,
    private contactService: ContactService,
    private afAuth: AngularFireAuth,
    private formBuilder: FormBuilder,
    private router: Router) { }

  ngOnInit(): void {

    this.initForm();
    this.afAuth.authState.subscribe(user => {
      this.currentUser = user;
    });
    this.getContacts();
    this.qrImage = environment.qrImage;
    this.title = environment.title;
  }

  initForm() {
    this.submitted = false;
    this.form = this.formBuilder.group({
      declarationNumber: new FormControl('', [Validators.required]),
      codeType: new FormControl(''),
      enterpriseName: new FormControl('', Validators.required),
      productName: new FormControl('', Validators.required),
      countProduct: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      expectedDeliveryDate: new FormControl('', Validators.required),
      expectedDeliveryHour: new FormControl('', Validators.required),
      receiverName: new FormControl('', Validators.required),
      receiverPhone: new FormControl('', Validators.required),
      note: new FormControl('')
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  create() {
    this.submitted = true;
    if (this.form.controls['declarationNumber'].value.toString().length < 11) {
      this.isEnoughNumber = true;
      return;
    }
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }
    // this.registrationService.search(declarationNumber).subscribe(data => {
    //   let registrationVerify = data[0];
    //   if (registrationVerify) {
    //     // Exist declaration number
    //     if (confirm("Số tờ khai \"" + declarationNumber + "\" đã tồn tại. Bạn có muốn cập nhật thông tin? ")) {
    //       this.form.value.id = registrationVerify["id"];
    //       this.registrationService.updateRegistrationVerify(this.form.value).then(data => {
    //         alert('Cập nhật tờ khai ' + declarationNumber + 'thành công');
    //         return;
    //       });
    //     } else {
    //       return;
    //     }
    //   } else {
    this.form.value.createdDate = Date.now();
    this.form.value.declarationNumber = this.form.value.declarationNumber.toString();
    this.registrationService.createRegistrationVerify(this.form.value).then(() => {
      this.isRequestSuccess = true;
      this.initForm();
      setTimeout(() => {
        this.isRequestSuccess = false;
      }, 3000)
    });
    // }
    // })
  }

  getContacts() {
    this.contactService.getContacts().subscribe(data => {
      this.contacts = data;
    });
  }
}
